export default __webpack_public_path__ + "static/media/28-2-mastercard.e34be9dc.jpg";